/** Gate module sub-pages — each maps to a gate pass purpose filter. */
export const GATE_MODULES = {
  procurement: {
    key: "procurement",
    purpose: "INWARD_PADDY",
    lockedPurpose: "INWARD_PADDY",
    eyebrow: "Gate · Procurement",
    title: "Procurement (Inward)",
    description: "Register inward paddy trucks, track yard presence, and process exit approvals for procurement vehicles.",
    newPassLabel: "New inward pass",
    formTitle: "New procurement gate pass",
    testId: "gate-procurement-page",
    showWorkflowLinks: true,
    hidePurposeColumn: true,
  },
  outward: {
    key: "outward",
    purpose: "OUTWARD_RICE",
    lockedPurpose: "OUTWARD_RICE",
    eyebrow: "Gate · Outward",
    title: "Outward Supply",
    description: "Rice and outward dispatch vehicles — entry, yard tracking, and exit for outbound supply.",
    newPassLabel: "New outward pass",
    formTitle: "New outward supply pass",
    testId: "gate-outward-page",
    showWorkflowLinks: true,
    hidePurposeColumn: true,
  },
  visitors: {
    key: "visitors",
    purpose: "VISITOR",
    lockedPurpose: "VISITOR",
    eyebrow: "Gate · Visitors",
    title: "Visitor Entry",
    description: "Walk-in and escorted visitors — register entry, monitor on-premises visitors, and check out on exit.",
    newPassLabel: "New visitor entry",
    formTitle: "New visitor entry",
    testId: "gate-visitors-page",
    showWorkflowLinks: false,
    hidePurposeColumn: true,
  },
  store: {
    key: "store",
    purpose: "INWARD_STORE",
    lockedPurpose: "INWARD_STORE",
    eyebrow: "Gate · Store",
    title: "Store inward",
    description: "Packing material, spares, consumables and fixed-asset trucks — link the PO at the gate so store can inspect.",
    newPassLabel: "New store inward pass",
    formTitle: "New store inward pass",
    testId: "gate-store-page",
    showWorkflowLinks: false,
    hidePurposeColumn: true,
  },
};

export const GATE_MODULE_ORDER = ["procurement", "store", "outward", "visitors"];

export function gateModuleFromPath(pathname) {
  if (pathname.startsWith("/gate/outward")) return GATE_MODULES.outward;
  if (pathname.startsWith("/gate/visitors")) return GATE_MODULES.visitors;
  if (pathname.startsWith("/gate/store")) return GATE_MODULES.store;
  return GATE_MODULES.procurement;
}
